import { render, staticRenderFns } from "./DashboardFreestall.vue?vue&type=template&id=0a7719f0&scoped=true&"
import script from "./DashboardFreestall.vue?vue&type=script&lang=js&"
export * from "./DashboardFreestall.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFreestall.vue?vue&type=style&index=0&id=0a7719f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7719f0",
  null
  
)

export default component.exports